import { render, staticRenderFns } from "./PositionSearch.vue?vue&type=template&id=09968a86&"
import script from "./PositionSearch.vue?vue&type=script&lang=js&"
export * from "./PositionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports